module.exports = "<div class=footer> <div> <strong>Copyright</strong> <a ng-href=\"{{ env.BRAND_HOME_URL }}\" target=_blank>{{ env.BRAND_COMPANY }}</a> &copy; 2016-{{ date | date:'yyyy' }} - <a target=_blank href=https://clerk.ai/legal/terms-of-service/ >Terms of Service</a> - <a target=_blank href=https://clerk.ai/legal/privacy-policy/ >Privacy Policy</a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/common/footer.html
// module id = 4187
// module chunks = 86